import './nuevoStroLight.css';
import { Link } from 'react-router-dom';

export default function ModuloDenunciaContractualesLight({ stro, sicobe, frente, carga2, pagosAnteriores, cobert }) {
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }
  const openInNewTab = (url, e) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  
  return (
    <section className='mainStroLightIzq'>
      <div className='stro-fields-grid'>
        {/* Fila 1 */}
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>Fecha Stro</span>
          <div className='burbujaTextoStroLight'>{formatDate(stro?.fechaStro)}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>Fecha Den</span>
          <div className='burbujaTextoStroLight'>{formatDate(stro?.fechaDenuncia)}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>Poliza</span>
          <div className='burbujaTextoStroLight'>
            <Link onClick={e => openInNewTab(`https://www.agsnet.com.ar/muestro-polizas2.php?prop=${stro?.qnx?.ados_nro_cc}&rtn=consulta-polizas`)}>{stro?.qnx?.ados_poliza}</Link>
          </div>
        </div>

        {/* Fila 2 */}
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 6' }}>
          <span className='spanBurbujaTextoStroLight'>Nombre Aseg</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_nom_aseg}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 6' }}>
          <span className='spanBurbujaTextoStroLight'>Productor</span>
          <div className='burbujaTextoStroLight'>
            {stro?.productor?.pro_productor} - {stro?.productor?.pro_raz_social}
          </div>
        </div>

        {/* Fila 3 */}
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 6' }}>
          <span className='spanBurbujaTextoStroLight'>Direccion Aseg</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_dir_aseg}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>Localidad Aseg</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_loc_aseg}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 2' }}>
          <span className='spanBurbujaTextoStroLight'>C.P</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_cdp_aseg}</div>
        </div>

        {/* Fila 4 */}
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 3' }}>
          <span className='spanBurbujaTextoStroLight'>Patente</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_patente}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 6' }}>
          <span className='spanBurbujaTextoStroLight'>Marca/Modelo</span>
          <div className='burbujaTextoStroLight'>
            {stro?.qnx?.ados_vehiculo} - {stro?.qnx?.ados_modelo}
          </div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 3' }}>
          <span className='spanBurbujaTextoStroLight'>Tipo Vehículo</span>
          <div className='burbujaTextoStroLight'>{stro?.item?.length > 0 ? stro?.item[0]?.item_desc : null}</div>
        </div>

        {/* Fila 5 */}
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>USO</span>
          <div className='burbujaTextoStroLight'>{stro?.uso?.length > 0 ? stro?.uso[0]?.uso_desc : null}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>COBERTURA</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_cobert}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>Suma Aseg</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_sum_aseg}</div>
        </div>

        {/* Fila 6 */}
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>N° Motor</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_motor}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>Chasis</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_chasis}</div>
        </div>
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>Valor GNC</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_eq_gas}</div>
        </div>
        {/* Fila 7 */}
       {stro?.qnx?.ados_gruapp !== 0 && (
        <div className='d-flex flex-column w-100' style={{ gridColumn: 'span 4' }}>
          <span className='spanBurbujaTextoStroLight'>ADICIONAL GRUAPP</span>
          <div className='burbujaTextoStroLight'>SI</div>
        </div>
       )}
      </div>
    </section>
  );
}
